import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { MediaCell } from '../../overviews/list-view/components/cells/media-cell/media-cell.entity';
import { TextCell } from '../../overviews/list-view/components/cells/text-cell/text-cell.entity';
import { ColumnDef } from '../../overviews/list-view/entities/column-definition.entity';
import { ColumnWidth } from '../../overviews/list-view/entities/column-width.entity';
import { HierarchyItem } from '../entities/hierarchy-item.entity';
import { sessionStorageHelper } from '../../session-storage/helpers/fetch-from-session-storage/session-storage.helper';

export type HierarchyColumn = ColumnDef<typeof HierarchyColumnService, HierarchyItem>;

@Injectable({ providedIn: 'root' })
export class HierarchyColumnService {
    static MEDIA: HierarchyColumn;
    static CURRENT_ITEM: HierarchyColumn;

    constructor(private readonly translateService: TranslateService) {
        HierarchyColumnService.MEDIA = new ColumnDef({
            key: 'MEDIA',
            translateLabel: `hierarchy.item`,
            mapper: (hierarchyItem: HierarchyItem) =>
                new MediaCell({
                    title: hierarchyItem.fragment.getTitle(),
                    imgSrc: hierarchyItem.fragment.getThumbnailUrl(),
                    navigationLink: {
                        route: sessionStorageHelper.has('shareId')
                            ? hierarchyItem.fragment.getShareDetailUrl(sessionStorageHelper.get('shareId')!)
                            : hierarchyItem.fragment.getDetailUrl()
                    }
                }),
            width: ColumnWidth.WIDE
        });

        HierarchyColumnService.CURRENT_ITEM = new ColumnDef({
            key: 'CURRENT_ITEM',
            translateLabel: `hierarchy.current-item`,
            mapper: (hierarchyItem: HierarchyItem) =>
                new TextCell(
                    hierarchyItem.isCurrent ? this.translateService.instant(`hierarchy.list.current-item`) : ''
                ),
            width: ColumnWidth.NORMAL,
            headerHidden: true
        });
    }
}
